import React from 'react';
import { opening } from '../../../data/pulse';
export function OpeningScreen() {
  return <div className="flex flex-1 flex-col justify-center" data-id="element-230" data-mp="33vlb9rizh36y">
      <p className="text-[9.5px] uppercase tracking-micro text-blue" data-id="element-231" data-mp="33y7ghkiej6m0">{opening.eyebrow}</p>

      <h2 className="mt-4 font-display text-[29px] font-semibold leading-[1.04] tracking-tight text-navy" data-id="element-232" data-mp="2yx9z3a57uglk">
        {opening.headline[0]}
        <span className="mt-1 block text-blue" data-id="element-233" data-mp="3rlfnc6vhanq5">{opening.headline[1]}</span>
      </h2>

      <p className="mt-4 text-[12.5px] leading-relaxed text-mut" data-id="element-234" data-mp="3mmm746ot4ima">{opening.support}</p>

      <p className="mt-6 border-t border-line pt-5 font-display text-[17px] font-semibold leading-snug text-navy2" data-id="element-235" data-mp="3mop45aodnc0i">
        {opening.prompt}
      </p>

      <p className="mt-3 text-[12.5px] leading-relaxed text-mut" data-id="element-236" data-mp="3cvrkh17nfh0b">{opening.promise}</p>

      <p className="mt-auto pt-6 text-[9px] leading-snug text-mut" data-id="element-237" data-mp="e7arx2vzwbk0">{opening.footnote}</p>
    </div>;
}